import { render, staticRenderFns } from "./SubscribeTags.vue?vue&type=template&id=5a198a22&"
import script from "./SubscribeTags.vue?vue&type=script&lang=js&"
export * from "./SubscribeTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports